export function getNavbarLinks() {
  return ["projects", "tech-stack", "about-me", "contacts"];
}

export function getHomeLink() {
  return ["home"];
}
